<template>
    <div>
        <v-row
            v-for="(email, index) in emails"
            :key="index"
            no-gutters
            class="pb-2"
            style="flex-wrap: nowrap"
        >
            <v-col class="shrink ml-1">
                <div style="max-height: 16px; align-content: center"><icon small color="g4" icon="Mail"></icon></div>
            </v-col>
            <v-col class="body-2 ml-3">
                <div class="font-weight-medium align-center">
                    {{ email.sender_name ? email.sender_name : email.email_integration.sender_name }}
                    <v-icon v-if="email.is_default" class="ml-3" color="secondary" :size="20">
                        mdi-star
                    </v-icon>
                </div>
                <div style="display: grid;">
                    <RawCustomField :value="email.email_integration.email"/>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {computed} from "@vue/composition-api";
import RawCustomField from "../../../components/Sidebar/Fields/RawCustomField.vue";

export default {
    name: "ClientEmailsList",
    components: {RawCustomField},
    props: {
        client: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const emails = computed(() => {
            return props.client.emails
        })

        return {
            emails
        };
    }
};
</script>
